import { isSameDay, isWithinInterval } from "date-fns";

const isWithinScheduleException = (day: Date, from: Date, to: Date) => {
    return (
        isWithinInterval(day, {
            start: from,
            end: to,
        }) ||
        isSameDay(day, from) ||
        isSameDay(day, to)
    );
};
export { isWithinScheduleException };
